// ColorMixin.ts

import { Component, Mixins, Prop } from 'vue-property-decorator';
import { VuetifyMixin } from './VuetifyMixin';
import { isCloserToBlackOrWhite } from '@/helpers';
import { isEmpty } from '@/pipes';

export function scoutingScoreColorHex(score: number): string {
	if( Number(score) >= 90 ) return '#6A1B9A';     	// purple darken-3
	else if( Number(score) >= 80 ) return '#1B5E20';	// green darken-4
	else if( Number(score) >= 60 ) return '#558B2F';	// light-green darken-3
	else if( Number(score) >= 40 ) return '#9E9D24';	// lime darken-3
	else if( Number(score) >= 20 ) return '#BF360C';	// deep-orange darken-4
	else if( Number(score) >= 0 ) return '#B71C1C';		// red darken-4
	return 'primary';
}

@Component
export class ColorMixin extends Mixins(VuetifyMixin) {
	@Prop({ default: 'primary' }) color: string;

	colorWhite: string = '#FFFFFF';
	colorBlack: string = '#000000';
	
	IsCloserToBlackOrWhite(hex: string, opposite: boolean = false): string {
		return isCloserToBlackOrWhite(hex, opposite);
	}
	
	ComplementaryTextColor(color: string): string {
		const vueColor = this.getColor(color);
		if( this.IsCloserToBlackOrWhite(vueColor) === this.colorWhite ) return 'black--text';
		return 'white--text';
	}	

	getHexColor(vuetifyColorName: string): string {
		return this.getColor(vuetifyColorName);
	}	

	ScoutingScoreColor(score: number): string {
		if( isEmpty(score) ) return 'primary';
		
		if( score >= 90 ) return 'purple darken-3';
		else if( score >= 80 ) return 'green darken-4';
		else if( score >= 60 ) return 'light-green darken-3';
		else if( score >= 40 ) return 'lime darken-3';
		else if( score >= 20 ) return 'deep-orange darken-4';
		else if( score > 0 ) return 'red darken-4';
		return 'primary';
	}
	ScoutingScoreColorHex(score: number): string {
		return scoutingScoreColorHex(score);
	}

	ScoutingRatingColor(rating: Number) : string {	
		if( Number(rating) > 4.25 ) return 'purple darken-3';
		else if( Number(rating) > 3.25 ) return 'green darken-4';
		else if( Number(rating) > 2.75 ) return 'light-green darken-3';
		else if( Number(rating) > 1.75 ) return 'lime darken-3';
		else if( Number(rating) > 0.75 ) return 'deep-orange darken-4';
		else if( Number(rating) > 0 ) return 'red darken-4';
		return  this.color;
	}

	ScoutingRatingTextColor(rating: Number) : string {
		if( Number(rating) > 4.25 ) return 'white';
		else if( Number(rating) > 3.25 ) return 'white';
		else if( Number(rating) > 2.75 ) return 'white';
		else if( Number(rating) > 1.75 ) return 'white';
		else if( Number(rating) > 0.75 ) return 'white';
		else if( Number(rating) > 0 ) return 'white';
		return  this.color;
	}
}